export default "<app-header></app-header>\r\n\r\n<div class=\"content\">\r\n    <app-portfolio></app-portfolio>\r\n</div>"